module.exports = __webpack_public_path__ + "img/exerciceIncomingDrone.6fbbd351.png";